import React, { useState } from 'react';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        guests: '2',
        date: '',
        time: '',
        message: '',
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        alert('Reservation request submitted! We will contact you shortly.');
        setFormData({ name: '', email: '', phone: '', guests: '2', date: '', time: '', message: '' });
    };

    const contactInfo = [
        {
            icon: '📍',
            title: 'Visit Us',
            details: ['Jl. Kuliner Raya No. 123', 'Jakarta Selatan, 12345'],
        },
        {
            icon: '📞',
            title: 'Call Us',
            details: ['+62 21 1234 5678', '+62 812 3456 7890'],
        },
        {
            icon: '⏰',
            title: 'Opening Hours',
            details: ['Monday - Sunday', '10:00 AM - 10:00 PM'],
        },
        {
            icon: '✉️',
            title: 'Email Us',
            details: ['info@delicious.com', 'reservations@delicious.com'],
        },
    ];

    return (
        <section id="contact" style={styles.section}>
            <div style={styles.container}>
                <div style={styles.header}>
                    <span style={styles.label}>GET IN TOUCH</span>
                    <h2 style={styles.heading}>Book Your Table</h2>
                    <p style={styles.subheading}>
                        Reserve your spot and enjoy an unforgettable dining experience
                    </p>
                </div>

                <div style={styles.content}>
                    <div style={styles.infoSection}>
                        <div style={styles.infoCards}>
                            {contactInfo.map((info, index) => (
                                <div key={index} style={styles.infoCard}>
                                    <span style={styles.infoIcon}>{info.icon}</span>
                                    <div>
                                        <h3 style={styles.infoTitle}>{info.title}</h3>
                                        {info.details.map((detail, idx) => (
                                            <p key={idx} style={styles.infoDetail}>{detail}</p>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div style={styles.mapPlaceholder}>
                            <span style={styles.mapEmoji}>🗺️</span>
                            <p style={styles.mapText}>Interactive Map Location</p>
                        </div>
                    </div>

                    <div style={styles.formSection}>
                        <div style={styles.formCard}>
                            <h3 style={styles.formTitle}>Make a Reservation</h3>
                            <p style={styles.formSubtitle}>Fill in the details below</p>

                            <form onSubmit={handleSubmit} style={styles.form}>
                                <div style={styles.formRow}>
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Your Name *"
                                        value={formData.name}
                                        onChange={handleChange}
                                        style={styles.input}
                                        required
                                    />
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Email Address *"
                                        value={formData.email}
                                        onChange={handleChange}
                                        style={styles.input}
                                        required
                                    />
                                </div>

                                <div style={styles.formRow}>
                                    <input
                                        type="tel"
                                        name="phone"
                                        placeholder="Phone Number *"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        style={styles.input}
                                        required
                                    />
                                    <select
                                        name="guests"
                                        value={formData.guests}
                                        onChange={handleChange}
                                        style={styles.input}
                                    >
                                        <option value="1">1 Guest</option>
                                        <option value="2">2 Guests</option>
                                        <option value="3">3 Guests</option>
                                        <option value="4">4 Guests</option>
                                        <option value="5">5+ Guests</option>
                                    </select>
                                </div>

                                <div style={styles.formRow}>
                                    <input
                                        type="date"
                                        name="date"
                                        value={formData.date}
                                        onChange={handleChange}
                                        style={styles.input}
                                        required
                                    />
                                    <input
                                        type="time"
                                        name="time"
                                        value={formData.time}
                                        onChange={handleChange}
                                        style={styles.input}
                                        required
                                    />
                                </div>

                                <textarea
                                    name="message"
                                    placeholder="Special requests (optional)"
                                    value={formData.message}
                                    onChange={handleChange}
                                    style={styles.textarea}
                                    rows="4"
                                />

                                <button type="submit" style={styles.submitButton}>
                                    Book Now
                                    <span style={styles.buttonArrow}>→</span>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const styles = {
    section: {
        padding: '6rem 2rem',
        backgroundColor: 'var(--cream)',
    },
    container: {
        maxWidth: '1400px',
        margin: '0 auto',
    },
    header: {
        textAlign: 'center',
        marginBottom: '4rem',
    },
    label: {
        color: 'var(--maroon)',
        fontSize: '0.9rem',
        fontWeight: '700',
        letterSpacing: '2px',
        marginBottom: '1rem',
        display: 'block',
    },
    heading: {
        fontSize: '3rem',
        fontWeight: '800',
        color: 'var(--dark)',
        marginBottom: '1rem',
        letterSpacing: '-1px',
    },
    subheading: {
        fontSize: '1.2rem',
        color: '#666',
        maxWidth: '600px',
        margin: '0 auto',
    },
    content: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '3rem',
    },
    infoSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2rem',
    },
    infoCards: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '1.5rem',
    },
    infoCard: {
        backgroundColor: 'var(--white)',
        padding: '2rem',
        borderRadius: '20px',
        display: 'flex',
        gap: '1rem',
        alignItems: 'flex-start',
        boxShadow: '0 5px 20px rgba(0,0,0,0.05)',
    },
    infoIcon: {
        fontSize: '2.5rem',
    },
    infoTitle: {
        fontSize: '1.2rem',
        fontWeight: '700',
        color: 'var(--dark)',
        marginBottom: '0.5rem',
    },
    infoDetail: {
        fontSize: '0.95rem',
        color: '#666',
        marginBottom: '0.3rem',
    },
    mapPlaceholder: {
        backgroundColor: 'var(--white)',
        borderRadius: '20px',
        height: '250px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 5px 20px rgba(0,0,0,0.05)',
    },
    mapEmoji: {
        fontSize: '4rem',
        marginBottom: '1rem',
    },
    mapText: {
        fontSize: '1rem',
        color: '#666',
    },
    formSection: {
        display: 'flex',
        flexDirection: 'column',
    },
    formCard: {
        backgroundColor: 'var(--white)',
        padding: '3rem',
        borderRadius: '25px',
        boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
    },
    formTitle: {
        fontSize: '2rem',
        fontWeight: '800',
        color: 'var(--dark)',
        marginBottom: '0.5rem',
    },
    formSubtitle: {
        fontSize: '1rem',
        color: '#666',
        marginBottom: '2rem',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
    },
    formRow: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '1rem',
    },
    input: {
        padding: '1.2rem',
        fontSize: '1rem',
        border: '2px solid #e5e5e5',
        borderRadius: '12px',
        outline: 'none',
        transition: 'all 0.3s ease',
        fontFamily: 'inherit',
    },
    textarea: {
        padding: '1.2rem',
        fontSize: '1rem',
        border: '2px solid #e5e5e5',
        borderRadius: '12px',
        outline: 'none',
        resize: 'vertical',
        fontFamily: 'inherit',
        transition: 'all 0.3s ease',
    },
    submitButton: {
        backgroundColor: 'var(--maroon)',
        color: 'var(--white)',
        padding: '1.3rem 2rem',
        fontSize: '1.1rem',
        border: 'none',
        borderRadius: '12px',
        cursor: 'pointer',
        fontWeight: '700',
        transition: 'all 0.3s ease',
        boxShadow: '0 10px 30px rgba(139, 46, 59, 0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.5rem',
    },
    buttonArrow: {
        fontSize: '1.2rem',
        transition: 'transform 0.3s ease',
    },
};

export default Contact;